import i18n from '@/utils/i18n';
import React from 'react';
import TrashIcon from '@assets/icons/trash-small.svg';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { List } from '@/components/list';

interface Props {
  onClear: () => void;
  onClose: () => void;
}

export const CreditRequestActionSheet: React.FC<Props> = ({
  onClear,
  onClose,
}) => {
  const [styles, theme] = useStyles();

  const actions = [
    {
      metadata: {
        Icon: TrashIcon,
        iconProps: {
          stroke: theme.sk.color.icon.negative.primary,
        },
        listTitleStyle: styles.deleteTitle,
        onSelect: onClear,
      },
      title: i18n.t('clear_all'),
      value: i18n.t('clear_all'),
    },
  ];

  return (
    <BaseActionSheet isVisible onClose={onClose}>
      <List
        data={actions}
        listItemStyle={styles.selectList}
        listItemTitleStyle={(item) => {
          const { listTitleStyle } = item.metadata;
          return listTitleStyle;
        }}
        onSelect={(item) => {
          const { onSelect } = item.metadata;
          onSelect();
          onClose();
        }}
        renderLeftComponent={(item) => {
          const { Icon, iconProps } = item.metadata;
          return (
            <Icon height={24} style={styles.icon} width={24} {...iconProps} />
          );
        }}
      />
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  deleteTitle: {
    color: theme.sk.color.text.error,
  },
  icon: {
    marginRight: 8,
  },
  selectList: {
    paddingHorizontal: 0,
    paddingVertical: 8,
  },
}));
